import { useToast } from "@chakra-ui/react";
import { useNavigate } from "react-router-dom";

export default function useNotification() {
  const navigate = useNavigate();
  const toast = useToast();

  const requestNotificationPermission = () => {
    if (Notification.permission !== "granted") {
      Notification.requestPermission();
    }
  };

  const showNotification = ({
    title,
    body,
    chatID,
  }: {
    title: string;
    body: string;
    chatID?: string;
    soundUrl?: string;
  }) => {
    if (!("Notification" in window)) return;

    if (Notification.permission === "granted") {
      const notification = new Notification(title, { body });

      notification.onclick = () => {
        window.focus();
        navigate(`/chats${chatID ? "?cid=" + chatID : ""}`);
      };
    } else {
      toast({
        title,
        description: body,
        status: "info",
        duration: 5000,
        isClosable: true,
        position: "top-right",
      });
    }
    const audio = new Audio("/audio/unread.mp3");
    audio.play();
  };

  return { requestNotificationPermission, showNotification };
}
